import script from "./ServerVhostsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerVhostsTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerVhostsTab.vue?vue&type=style&index=0&id=2f3db64f&lang=scss"

const __exports__ = script;

export default __exports__